import React from "react";
import ReactDOM from "react-dom";
import "./style.css";
import FullPage from "./components/fullPage";

ReactDOM.render(<FullPage />, document.getElementById("root"));
